import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class CtvKriterBulAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "CtvKriterBul";
    super(baseUrl);
  }


  getCtvKriterBul( ctvKullanimSekliKodu?: number){
    var request= new CtvKriterBulRequest( ctvKullanimSekliKodu);
    
    return this.get("",{ params: { ctvKullanimSekliKodu: ctvKullanimSekliKodu } });
  }

}


export default new CtvKriterBulAPI();
class CtvKriterBulRequest {
  public ctvKullanimSekliKodu?: number;

 
  constructor(ctvKullanimSekliKodu?: number) {
   
      this.ctvKullanimSekliKodu = ctvKullanimSekliKodu;

      
  }
}
export { CtvKriterBulRequest };